// export const BASE_URL = "http://localhost:9002";
// export const DOMAIN = "http://localhost:9002";
export const BASE_URL = "https://demo.raipurbuilder.com/demo"; //new post api
export const DOMAIN = "https://demo.raipurbuilder.com";
